import { get } from "app/utils/axios/kheti";
import { Crop, PlantixError } from "../models/diagnosis";

export interface GetPlantixResponse {
  plantix_id: string;
  crops?: Crop[];
  status: 0 | 1 | 2;
  errors?: PlantixError[];
}

const getPlantixResponse = async (plantixId: string) => {
  try {
    const response = await get<GetPlantixResponse>(
      `plantix/v1/${plantixId}/response`
    );
    return response;
  } catch (e) {
    return null;
  }
};

export default getPlantixResponse;
